import { Theme } from '@mui/material';

import { ICallScribePalette, ICallScribeSpeakerTone } from 'constants/theme';

export const csTokens = (theme: Theme): ICallScribePalette => theme.palette.callScribe;

export const SPEAKER_TONE_COUNT = 6;

export const speakerTone = (theme: Theme, index: number): ICallScribeSpeakerTone => {
  const t = csTokens(theme);
  const slot = ((Math.trunc(index) % SPEAKER_TONE_COUNT) + SPEAKER_TONE_COUNT) % SPEAKER_TONE_COUNT;
  return [t.speaker1, t.speaker2, t.speaker3, t.speaker4, t.speaker5, t.speaker6][slot];
};

export const callGreen = (theme: Theme): string => theme.palette.callScribe.live;

export const endRed = (theme: Theme): string => theme.palette.callScribe.end;

export const callInk = (theme: Theme): string => theme.palette.callScribe.callInk;

export const endInk = (theme: Theme): string => theme.palette.callScribe.endInk;

export const callGroundSurface = (theme: Theme): { color: string; background: string } => ({
  color: csTokens(theme).onGround,
  background: csTokens(theme).ground,
});

export const secondaryText = (theme: Theme): string => csTokens(theme).text2;

export const subtleFill = (theme: Theme): string => csTokens(theme).surface2;

export const tertiaryText = (theme: Theme): string => csTokens(theme).text3;

export const focusRing = (theme: Theme): Record<string, string> => ({
  outline: `2px solid ${csTokens(theme).focus}`,
  outlineOffset: '2px',
});

export const CS_FONT = {
  caption: { fontSize: '12px', lineHeight: '16px' },
  small: { fontSize: '13px', lineHeight: '18px' },
  body: { fontSize: '15px', lineHeight: '22px' },
  title: { fontSize: '18px', lineHeight: '24px' },
  display: { fontSize: '24px', lineHeight: '28px' },
} as const;

export const CS_WEIGHT = { regular: 500, strong: 700, heavy: 800 } as const;

export const CS_Z = { sticky: 1, scrim: 2, sheet: 3, popover: 5, toast: 10 } as const;

export const CS_NARROW = '@media (max-width: 459px)';

/**
 * Translucent surface over the call-screen ground. `backdrop-filter` is not
 * universally supported, so every glass rule ships an opaque fallback tint
 * first and only layers the blur where the browser advertises support.
 */
export const glassSurface = (
  theme: Theme,
  strong = false,
): Record<string, string | Record<string, string>> => {
  const t = csTokens(theme);
  return {
    background: t.glassFallback,
    border: `1px solid ${t.glassBorder}`,
    '@supports (backdrop-filter: blur(1px))': {
      background: strong ? t.glassStrong : t.glass,
      backdropFilter: 'blur(18px) saturate(140%)',
    },
  };
};
